import { NodeModel } from '@minoru/react-dnd-treeview';
import { WorkshiftsSchedulingsCopied } from '../../models/copy-paste/CopyPaste';
import { EmployeeNodeModel } from '../../models/groupedEmployee.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    workshiftsSchedulingsCopied: WorkshiftsSchedulingsCopied;
    openSavePasteWorkshiftsSchedulings: (
        initDate: string,
        startDate: string,
        lastDate: string,
        endDate: string,
        selectedEmployees: EmployeeNodeModel[],
        employeesTree: EmployeeNodeModel[]
    ) => void;
};

export const controllerPasteWorkshiftSchedulings = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    workshiftsSchedulingsCopied,
    openSavePasteWorkshiftsSchedulings,
}: Props) => {
    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);

    let dates = getDatesBetweenDates(initDate, lastDate);

    // Arreglo
    if (initDate && lastDate && workshiftsSchedulingsCopied.toCopy.length === 1) {
        openSavePasteWorkshiftsSchedulings(
            initDate,
            startDate,
            lastDate,
            endDate,
            selectedEmployees,
            treeEmployees
        );
    }

    // Matrices
    else if (
        initDate &&
        lastDate &&
        workshiftsSchedulingsCopied.toCopy.length ===
            selectedEmployees.filter((x, i, a) => a.indexOf(x) === i).length &&
        workshiftsSchedulingsCopied.toCopy[0].workshiftSchedulingsIds.length ===
            dates.length
    ) {
        openSavePasteWorkshiftsSchedulings(
            initDate,
            startDate,
            lastDate,
            endDate,
            selectedEmployees,
            treeEmployees
        );
    }
};
